















































import { Component, Vue } from "vue-property-decorator";

import { moveGroup } from "@/move-group";

import SettingItem from "@/components/SettingItem.vue";
import { ILottoTicket } from "@/interface";
import { MTGSetType } from "@/enum";

@Component({
    name: "SettingsItemGroup",
    components: {
        SettingItem,
    },
    props: {
        header: String,
        tickets: Array,
    },
})
export default class SettingsItemGroup extends Vue {

    private tickets: ILottoTicket[] | undefined;

    public toggleTicket(setCode: string): void {
        this.$emit("toggle", setCode);
    }
    public toggleAllTickets(ev: MouseEvent): void {
        if (this.tickets) {
            const enabledCount = this.tickets.reduce(
                (statusDiff, current) => statusDiff + (current.enabled ? 1 : -1),
                0,
            );
            const uniformGroup = Math.abs(enabledCount) === this.tickets.length;
            const majorityEnabled = 0 < enabledCount;

            if (uniformGroup) {
                this.setStateOnAllTickets(!majorityEnabled);
            } else {
                this.setStateOnAllTickets(!ev.ctrlKey);
            }

        }
    }

    public moveGroup(ev: KeyboardEvent): void {
        return moveGroup(ev);
    }

    private setStateOnAllTickets(state: boolean): void {
        if (this.tickets) {
            for (const ticket of this.tickets) {
                this.$emit("toggle", ticket.set.code, state);
            }
        }
    }
}
